import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ROUTES } from '@shared/config/routes';
import { cn } from '@shared/lib/cn';

interface Item {
  to: string;
  labelKey: string;
}

const ITEMS: Item[] = [
  { to: ROUTES.dashboard, labelKey: 'nav.dashboard' },
  { to: ROUTES.admins, labelKey: 'nav.admins' },
  { to: ROUTES.users, labelKey: 'nav.users' },
  { to: ROUTES.manufacturers, labelKey: 'nav.manufacturers' },
  { to: ROUTES.catalog, labelKey: 'nav.catalog' },
  { to: ROUTES.buyRequests, labelKey: 'nav.buyRequests' },
  { to: ROUTES.taxonomyCategories, labelKey: 'nav.categories' },
  { to: ROUTES.audit, labelKey: 'nav.audit' },
  { to: ROUTES.settings, labelKey: 'nav.settings' },
];

export function Sidebar() {
  const { t } = useTranslation();
  return (
    <aside className="hidden w-60 shrink-0 border-r bg-card md:flex md:flex-col">
      <div className="px-5 py-4 text-lg font-semibold tracking-tight">AIDU Admin</div>
      <nav className="flex flex-1 flex-col gap-0.5 px-2 pb-4">
        {ITEMS.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.to === ROUTES.dashboard}
            className={({ isActive }) =>
              cn(
                'rounded-md px-3 py-2 text-sm transition-colors',
                isActive
                  ? 'bg-primary/10 text-primary'
                  : 'text-muted-foreground hover:bg-accent hover:text-foreground',
              )
            }
          >
            {t(item.labelKey)}
          </NavLink>
        ))}
      </nav>
    </aside>
  );
}
